import { Icon } from '@tcweb/connect-ui';
import { JSXElement } from 'solid-js';

export interface MeasurementBoundaryIconButtonProps {
  icon: string;
  pressed?: boolean;
  onClick(): void;
  disabled?: boolean;
  color?: 'primary' | 'secondary' | 'tertiary' | 'warning' | 'danger';
}

/**
 * Boundary row icon buttons (draw / pick / delete).
 * Modus `IconButton` does not render tc-icon / cursor glyphs correctly here.
 * @see https://github.com/trimble-oss/modus-wc-2.0/issues/719
 */
export const MeasurementBoundaryIconButton = (
  props: MeasurementBoundaryIconButtonProps
): JSXElement => {
  return (
    <modus-wc-button
      onClick={() => props.onClick()}
      pressed={props.pressed ?? false}
      color={props.color ?? 'tertiary'}
      size="md"
      attr:custom-class={`w-10 ${props.pressed ? 'bg-gray-4' : ''}`}
      disabled={props.disabled}
    >
      <Icon modusHostClass="!me-0" class="justify-center " icon={props.icon} />
    </modus-wc-button>
  );
};
